import { FC, useState } from "react";
import SedeContextType from "../../../domain/providers/sede/SedeContextType";
import SedeEntity from "../../../domain/entities/SedeEntity";
import ProviderProps from "../../../domain/providers/ProviderProps";
import SedeContext from "../../../domain/providers/sede/SedeContext";
import SedeProvider from "../../../domain/providers/sede/SedeProvider";

const _Actions: SedeContextType = {
    sedes: [],
    setSedes: (sedes: SedeEntity[]) => {},
};

const _Provider: FC<ProviderProps> = ({ children }) => {
    const [sedes, setSedes] = useState<SedeEntity[]>([]);
    _Actions.setSedes = setSedes;
    _Actions.sedes = sedes;

    return <SedeContext.Provider value={{ sedes, setSedes }}>{children}</SedeContext.Provider>;
};

class SedeProviderImpl implements SedeProvider {
    public context = SedeContext;
    public Actions: SedeContextType = _Actions;
    public Provider: FC<ProviderProps> = _Provider;
}

export default new SedeProviderImpl();
